"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ConsoleLogger: function() {
        return ConsoleLogger;
    },
    ILogger: function() {
        return ILogger;
    }
});
const _classy = require("./classy");
let ILogger = class ILogger extends _classy.ClassyPlaceholder {
};
const ConsoleLogger = {
    // eslint-disable-next-line no-console
    info: console.info,
    // eslint-disable-next-line no-console
    warn: console.warn,
    // eslint-disable-next-line no-console
    error: console.error,
    // eslint-disable-next-line no-console
    trace: console.trace,
    // eslint-disable-next-line no-console
    debug: console.debug
};

//# sourceMappingURL=logger.js.map